export default __webpack_public_path__ + "static/media/STL_Investors_Presentation_signed.9fea8451.pdf";